<template>
  <div>
    <v-expansion-panels v-if="$breakpoint.is.smAndDown" v-model="expanded" class="px-3 py-2">
      <v-expansion-panel class="mobile-panel">
        <v-expansion-panel-header :expand-icon="expanded === 0 ? 'mdi-minus' : 'mdi-plus'">
          <h1>Reviews ({{ reviewCount }})</h1>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="goodreads-widget">
            <div class="hide-gr-review-showing" />
            <iframe
              :src="iframeSource"
              width="100%"
              height="300"
            />
            <div class="gr-footer">
              <a class="gr_branding" target="_blank" rel="nofollow noopener noreferrer" href="https://www.goodreads.com">Reviews from Goodreads.com</a>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-if="$breakpoint.is.mdAndUp">
      <div class="reviews-heading-block d-flex align-center justify-center">
        <div class="flex-column">
          <div class="bpg-title">
            <span>Reviews</span>
          </div>
          <div class="d-flex align-center mt-5 font-medium font-weight-bold">
            <span>Average Review:</span>
            <base-rating
              v-model="rating"
              readonly
              class="mx-1"
              :size="18"
            />
            <span class="primary--text">{{ reviewCount }} Reviews</span>
          </div>
        </div>
      </div>
      <div class="goodreads-widget">
        <div class="hide-gr-review-showing" />
        <iframe
          :src="iframeSource"
          width="575"
          height="400"
        />
        <div class="gr-footer">
          <a class="gr_branding" target="_blank" rel="nofollow noopener noreferrer" href="https://www.goodreads.com">Reviews from Goodreads.com</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductReviews',
  props: {
    isbn: {
      type: String,
      required: true
    },
    rating: {
      type: Number,
      required: true
    },
    reviewCount: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      expanded: null
    }
  },
  computed: {
    iframeSource () {
      return `https://www.goodreads.com/api/reviews_widget_iframe?did=DEVELOPER_ID&format=html&isbn=${this.isbn}&links=38668e&min_rating=&num_reviews=5&stars=66cc66&stylesheet=&text=3f434e`
    }
  }
}
</script>

<style scoped lang="scss">
  @import './scss/variables';

  .v-expansion-panel-header {
    z-index: 1
  }

  .bpg-title {
    margin-top: 0;
  }

  .reviews-heading-block {
    background-color: rgba(216, 216, 216, 0.3);
    width: 100%;
    min-height: 127px;
    position: relative;
    z-index: 1;
  }

  .hide-gr-review-showing {
    height: 58px;
    width: 100%;
    margin-top: -58px;
    margin-bottom: -58px;
    position: relative;
    background: #ffffff;
  }

  .goodreads-widget {
    padding: 18px 0;
    width: 100%;
    min-height: 600px;

    h1 {
      font-weight:normal;
      font-size: 16px;
      border-bottom: 1px solid $charcoal-grey;
      margin-bottom: 0;
    }

    a {
      text-decoration: none;
      color: $dark-blue;

      &:hover {
        text-decoration: underline;
      }

      &:active {
        color: $dark-blue;
      }
    }

    iframe {
      width: 100%;
      min-height: 600px;
      border: none;
    }

    .gr-footer {
      width: 100%;
      border-top: 1px solid $charcoal-grey;
      text-align: right;

      .gr_branding{
        color: #382110;
        font-size: 11px;
        text-decoration: none;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
    }
  }
</style>
